$(document).ready(function(){
	var playBtn = $('.blockVideo .icon--play');
	if (playBtn.length) {
		playBtn.on('click', function(){
			$(this).parents('.image').fadeOut();
			var type = $(this).parents('.video').attr('data-type');
			if (type == 'html') {
				// -- play video type html --
				var htmlVideo = $(this).parents('.video').find('video')[0]; 
				htmlVideo.currentTime = 0;
				htmlVideo.play();
			} else {
				// -- play video type iframe --
				var iframeVideo = $(this).parents('.video').find('iframe');
				if (iframeVideo.attr('data-src').indexOf('autoplay') >= 0) {
					iframeVideo.attr('data-src', function (index, oldSrc) {
				    return oldSrc.replace('autoplay=1', 'autoplay=0');
					});
				} else {
					iframeVideo.attr('data-src', iframeVideo.attr('data-src')+'&autoplay=1');
				}
				initVideoSrc(iframeVideo);
			}

		});

		function initVideoSrc(iframeVideo) {
			if (iframeVideo.attr('data-src')) {
				iframeVideo.attr('src', iframeVideo.attr('data-src'));
			}
		}
	}
});